var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
import { INSURER_CONFIG } from '@shared/insurer';
let TenantInsurerSupported = class TenantInsurerSupported extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/documents/refus-total.svg');
    }
    get showTitle() {
        var _a, _b, _c;
        return (_c = (_b = (_a = INSURER_CONFIG.declaration.pages) === null || _a === void 0 ? void 0 : _a.tenantInsurerSupported) === null || _b === void 0 ? void 0 : _b.displayTitle) !== null && _c !== void 0 ? _c : true;
    }
    get showCaseNumber() {
        var _a, _b, _c;
        return ((_c = (_b = (_a = INSURER_CONFIG.declaration.pages) === null || _a === void 0 ? void 0 : _a.tenantInsurerSupported) === null || _b === void 0 ? void 0 : _b.displayRememberContractNumber) !== null && _c !== void 0 ? _c : true);
    }
    get showButton() {
        var _a, _b, _c;
        return (_c = (_b = (_a = INSURER_CONFIG.declaration.pages) === null || _a === void 0 ? void 0 : _a.tenantInsurerSupported) === null || _b === void 0 ? void 0 : _b.displayButton) !== null && _c !== void 0 ? _c : true;
    }
};
TenantInsurerSupported = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
            goBack: null,
        },
    })
], TenantInsurerSupported);
export default TenantInsurerSupported;
